<template>
        <div class="d-flex h-100 flex-column">
            <div class="d-flex justify-content-end flex-grow-1 align-items-end" v-if="this.$root.app_is_loaded">
                <div class="container py-5">
                    <div class="row">
                        <div class="col-10 offset-1 text-center mb-2">
                            <router-link
                                :to="{ name: this.$root.locale + '.tickets' }"
                                class="btn btn-light btn-lg text-uppercase w-100 p-4">
                                <h1 class="fw-bold mb-1">{{ this.trans.get('kiosk.buy-your-tickets') }}</h1>
                                <span class="fw-light">{{ this.trans.get('kiosk.click-here-to-start') }}</span>
                            </router-link>
                        </div>
                    </div>

                    <div class="row" v-if="1==0">
                        <div class="col-10 offset-1 text-center">
                            <button @click="switchLocale" type="button" class="btn btn-secondary fw-bold text-uppercase w-100 p-3">
                                {{ this.trans.get('kiosk.change-language') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex-shrink-0 pt-5">
                <div class="row">
                    <div class="col-6 pb-3 ps-5 footer_copy projexmedia-font">{{ this.trans.get('kiosk.powered-by') }} <img class="footer_logo" src="/assets/kiosk/img/xpayrience_logo.svg"></div>
                    <div class="col-6 text-end pe-5 pb-3"><img @touchstart="this.start_logo_timer()" @mousedown="this.start_logo_timer()" @touchend="this.stop_timer()" @mouseup="this.stop_timer()" src="/assets/kiosk/img/lhjmq.jpg"></div>
                </div>
            </div>

        </div>



</template>

<script>
import { setApiLocale } from "../../helpers/kiosk-helpers";
import {defineComponent} from "vue";
import { useCookies } from '@vueuse/integrations/useCookies';


export default defineComponent({
    name: "HomeButtons",

    created() {

    },

    data() {
        return {
            show_buttons: true,
            logo_press_time:0,
            logo_timer:null,
        }
    },

    methods: {
        receive() {

        },

        start_logo_timer()
        {
            this.logo_timer = setInterval(this.add_logo_timer,1000);
        },
        add_logo_timer()
        {
            this.logo_press_time++;
            let time_to_hold = 1;
            if(this.logo_press_time >= time_to_hold)
            {
                this.$root.admin_show = true;
                this.stop_timer();
            }
        },
        stop_timer()
        {
            clearInterval(this.logo_timer);
            this.logo_press_time = 0;

        },

        switchLocale() {
            if(this.$root.locale === 'en')
            {
                this.$root.locale = 'fr';
            }
            else
            {
                this.$root.locale = 'en';
            }

            setApiLocale(this.$root.locale)
                .then(() => {
                    //
                });

            this.trans.setLocale(this.$root.locale);
            this.cookies.set('app_locale', this.$root.locale);
            this.$router.push({ name: this.$root.locale + '.home' });
        },
    },

    mounted() {

    },


    setup() {
        const cookies = useCookies(['locale']);

        return {
            cookies,
        }
    },

});
</script>

<style scoped>

</style>
